"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCrewName = exports.updateBookingActivity = exports.sendCrewInvitation = exports.removeExtrasProduct = exports.orderExtrasProduct = exports.getExtrasProducts = exports.getExtrasOrder = exports.getCrewMembers = exports.getBookingByCode = exports.getActiveBooking = exports.deleteCrewMember = exports.createPayment = exports.createExtrasOrder = exports.checkoutBooking = exports.checkPaymentInfo = exports.cancelExtrasOrder = exports.cancelBooking = exports.addUserToCrew = exports.activateDeferredBooking = void 0;
var getActiveBooking = exports.getActiveBooking = function getActiveBooking() {
  var bookingId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    if (loading) {
      dispatch({
        type: 'SET_BOOKING_LOADING',
        loading: true
      });
    }
    return fetch("/api/booking/".concat(bookingId || ''), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      dispatch({
        type: 'UPDATE_BOOKING',
        booking: undefined
      });
      dispatch({
        type: 'SET_BOOKING_ERROR',
        message: response.message
      });
      return null;
    })["catch"](function (ex) {
      return console.log('failed fetching booking', ex);
    });
  };
};
var getBookingByCode = exports.getBookingByCode = function getBookingByCode(bookingCode) {
  var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    if (loading) {
      dispatch({
        type: 'SET_BOOKING_LOADING',
        loading: true
      });
    }
    return fetch("/api/booking/code/".concat(bookingCode), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      dispatch({
        type: 'UPDATE_BOOKING',
        booking: undefined
      });
      dispatch({
        type: 'SET_BOOKING_ERROR',
        message: response.message
      });
      return null;
    })["catch"](function (ex) {
      return console.log('failed fetching booking by code', ex);
    });
  };
};
var activateDeferredBooking = exports.activateDeferredBooking = function activateDeferredBooking(bookingId) {
  return function (dispatch) {
    return fetch("/api/booking/activate-deferred/".concat(bookingId), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
      }
      return response;
    })["catch"](function (ex) {
      return console.error('failed to activate deferred booking', ex);
    });
  };
};
var cancelBooking = exports.cancelBooking = function cancelBooking(bookingId) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(bookingId, "/cancel"), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: undefined
        });
      }
    })["catch"](function (ex) {
      return console.error('failed canceling booking', ex);
    });
  };
};
var checkoutBooking = exports.checkoutBooking = function checkoutBooking(bookingId) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(bookingId, "/checkout"), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      return null;
    })["catch"](function (ex) {
      return console.log('failed booking checkout', ex);
    });
  };
};
var updateBookingActivity = exports.updateBookingActivity = function updateBookingActivity(bookingId) {
  return function (dispatch) {
    fetch("/api/booking/".concat(bookingId, "/keep-alive"), {
      method: 'POST',
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING_ACTIVITY'
        });
      } else if (response.status === 'failed') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: undefined
        });
      }
      return response;
    });
  };
};
var deleteCrewMember = exports.deleteCrewMember = function deleteCrewMember(member, bookingId) {
  return function (dispatch) {
    var memberId = member.id;
    return fetch("/api/booking/".concat(bookingId, "/delete-crew-member"), {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        crewMemberId: member.id
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'DELETE_MEMBER',
          memberId: memberId
        });
      }
      return response;
    });
  };
};
var addUserToCrew = exports.addUserToCrew = function addUserToCrew(booking) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(booking.id, "/add-user-to-crew"), {
      method: 'POST',
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'ADD_USER',
          crewMember: response.data
        });
      }
      return response;
    });
  };
};
var sendCrewInvitation = exports.sendCrewInvitation = function sendCrewInvitation(booking, emails) {
  return function (dispatch) {
    var bookingId = booking.id;
    return fetch("/api/booking/".concat(bookingId, "/send-invites"), {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        emails: emails
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'INVITE_EMAILS',
          crewInvites: response.data.crewInvites
        });
      }
      return response;
    });
  };
};
var updateCrewName = exports.updateCrewName = function updateCrewName(booking, crewName) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(booking.id, "/update-crew-name"), {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        crewName: crewName
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_CREW_DATA',
          booking: response.data
        });
      }
      return response;
    });
  };
};
var getExtrasProducts = exports.getExtrasProducts = function getExtrasProducts(bookingId, isPaying) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(bookingId, "/extras/shop").concat(isPaying ? '?isPaying=true' : ''), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_EXTRAS_PRODUCTS',
          extrasProducts: response.data.products
        });
      }
      return response;
    })["catch"](function (error) {
      console.error('failed fetching extras', error);
      return {
        status: 'failed',
        error: {
          message: error.message
        }
      };
    });
  };
};
var orderExtrasProduct = exports.orderExtrasProduct = function orderExtrasProduct(bookingId, type, updater, product, variant) {
  var quantity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
  return function (dispatch) {
    return fetch("/api/booking/".concat(bookingId, "/extras/shop"), {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        type: type,
        updater: updater,
        product: product,
        variant: variant,
        quantity: quantity
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success' && response.data) {
        dispatch({
          type: 'SET_EXTRAS_PRODUCTS',
          extrasProducts: response.data.products
        });
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data.booking
        });
      }
      return response;
    })["catch"](function (error) {
      console.error('failed ordering a product', error);
      return {
        status: 'failed',
        error: {
          message: error.message
        }
      };
    });
  };
};
var removeExtrasProduct = exports.removeExtrasProduct = function removeExtrasProduct(bookingId, type, updater, product, variant) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(bookingId, "/extras/shop"), {
      method: 'DELETE',
      credentials: 'same-origin',
      body: JSON.stringify({
        type: type,
        updater: updater,
        product: product,
        variant: variant
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success' && response.data) {
        dispatch({
          type: 'SET_EXTRAS_PRODUCTS',
          extrasProducts: response.data.products
        });
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data.booking
        });
      }
      return response;
    })["catch"](function (error) {
      console.error('failed removing a product', error);
      return {
        status: 'failed',
        error: {
          message: error.message
        }
      };
    });
  };
};
var createPayment = exports.createPayment = function createPayment(orderId, amount, token, currency, service, cardHolder, cardScheme) {
  var useThreeDs = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  var isCreatingScheduledPayments = arguments.length > 8 ? arguments[8] : undefined;
  var paymentOption = arguments.length > 9 ? arguments[9] : undefined;
  var cardType = arguments.length > 10 ? arguments[10] : undefined;
  var billingCountry = arguments.length > 11 ? arguments[11] : undefined;
  var isScheduledPaymentsUpdate = arguments.length > 12 ? arguments[12] : undefined;
  return function (dispatch, getState) {
    return fetch('/api/payment/create', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        orderId: orderId,
        token: token,
        amount: amount,
        currency: currency,
        service: service,
        cardHolder: cardHolder,
        cardScheme: cardScheme,
        useThreeDs: useThreeDs,
        isCreatingScheduledPayments: isCreatingScheduledPayments,
        paymentOption: paymentOption,
        cardType: cardType,
        billingCountry: billingCountry,
        isScheduledPaymentsUpdate: isScheduledPaymentsUpdate
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success' && response.data) {
        dispatch({
          type: 'ADD_PAYMENT',
          payment: response.data
        });
        // Refresh Booking to get up-to-date version of MainOrder:
        var booking = getState().booking.currentBooking;
        if (booking) {
          getActiveBooking(booking.id, false)(dispatch);
          getCrewMembers(booking.id)(dispatch);
        }
      }
      if (response.status === 'redirect') {
        window.location.href = response.data;
      }
      return response;
    })["catch"](function (error) {
      console.error('failed making a payment', error);
      return {
        status: 'failed',
        error: {
          message: error.message
        }
      };
    });
  };
};
var checkPaymentInfo = exports.checkPaymentInfo = function checkPaymentInfo(orderId, token, service, scheduledPayments) {
  var isScheduledPaymentsUpdate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch, getState) {
    return fetch('/api/payment/check-token', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        orderId: orderId,
        token: token,
        service: service,
        scheduledPaymentsData: scheduledPayments,
        isScheduledPaymentsUpdate: isScheduledPaymentsUpdate
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.data) {
        dispatch({
          type: 'ADD_PAYMENT',
          payment: response.data
        });
        // Refresh Booking to get up-to-date version of MainOrder:
        var booking = getState().booking.currentBooking;
        if (booking) {
          getActiveBooking(booking.id, false)(dispatch);
          getCrewMembers(booking.id)(dispatch);
        }
      }
      return response;
    })["catch"](function (error) {
      console.error('failed checking payment', error);
      return {
        status: 'failed',
        error: {
          message: error.message
        }
      };
    });
  };
};
var getCrewMembers = exports.getCrewMembers = function getCrewMembers(bookingId) {
  return function (dispatch) {
    return fetch("/api/booking/".concat(bookingId, "/crew-members"), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_CREW',
          data: response.data
        });
      }
      return response;
    })["catch"](function (error) {
      console.error('failed fetching crew members', error);
      return {
        status: 'failed',
        error: {
          message: error.message
        }
      };
    });
  };
};
var createExtrasOrder = exports.createExtrasOrder = function createExtrasOrder(booking, productVariants) {
  return fetch("/api/booking/".concat(booking.id, "/create-extras-order"), {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      productVariants: productVariants
    })
  }).then(function (response) {
    return response.json();
  });
};
var cancelExtrasOrder = exports.cancelExtrasOrder = function cancelExtrasOrder(order, booking) {
  return fetch("/api/booking/".concat(booking.id, "/cancel-extras-order"), {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      order: order
    })
  }).then(function (response) {
    return response.json();
  });
};
var getExtrasOrder = exports.getExtrasOrder = function getExtrasOrder(orderId) {
  return fetch("/api/booking/order/".concat(orderId), {
    method: 'GET',
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json();
  });
};